import { useEffect } from "react";

export default function ConfirmModal({ testid, title, body, confirmLabel, onCancel, onConfirm }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onCancel(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);
  return (
    <div className="fixed inset-0 z-[60] bg-[#1A1F2C]/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onCancel}>
      <div data-testid={testid} className="bg-[#F8F5EE] rounded-xl w-full max-w-md shadow-2xl p-6" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-serif text-2xl text-[#1A1F2C]">{title}</h3>
        <p className="text-sm text-[#3D3A35] mt-3 leading-relaxed">{body}</p>
        <div className="flex justify-end gap-3 mt-6">
          <button data-testid={`${testid}-cancel`} onClick={onCancel} className="px-4 py-2 text-sm text-[#6B6358]">Cancel</button>
          <button
            data-testid={`${testid}-confirm`}
            onClick={onConfirm}
            className="px-5 py-2 bg-[#B5462F] text-white rounded-full text-sm font-medium"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
